<template>
  <div class="text-center">
    <v-dialog v-model="modalStatus" max-width="620" scrollable persistent>
      <v-card>
        <v-card-title class="text-primary font-weight-bold py-3 px-5">
          <v-icon color="#2D4B95" class="mr-2" small>mdi-cog</v-icon>
          Configurar Módulo Entregas
        </v-card-title>

        <v-tabs v-model="activeTab" background-color="#f5f5f5" color="#2D4B95" grow height="38">
          <v-tab v-for="tab in tabs" :key="tab.value" class="tab-item">{{ tab.name }}</v-tab>
        </v-tabs>

        <v-card-text class="pa-0" style="max-height: 480px; overflow-y: auto;">
          <v-tabs-items v-model="activeTab">

            <!-- Tab 1: Base -->
            <v-tab-item>
              <div class="py-3 px-5">

                <!-- Aprobadores -->
                <div class="section-label mb-2">Aprobadores</div>

                <!-- Header de columnas -->
                <div class="approver-header d-flex align-center px-2 mb-1">
                  <div style="width: 36px;"></div>
                  <div class="approver-header-name"></div>
                  <div class="approver-header-ranges d-flex">
                    <span class="header-col">Máx. aprobaciones</span>
                  </div>
                </div>

                <div
                  v-for="(subject, index) in $store.usersStore.state.jobTypes.filter(i => i.id !== 4)"
                  :key="index"
                  class="approver-row d-flex align-center px-2 mb-1"
                  :class="{ 'approver-row--disabled': !isApproverEnabled(subject.id) }"
                >
                  <v-switch
                    :value="subject.id"
                    v-model="enabledApprovers"
                    class="my-0 mr-2 flex-shrink-0"
                    dense
                    hide-details
                    style="width: 36px;"
                  ></v-switch>

                  <span
                    class="approver-name flex-grow-1"
                    :class="{ 'grey--text': !isApproverEnabled(subject.id) }"
                  >
                    {{ subject.name }}
                  </span>

                  <div class="approver-ranges d-flex align-center">
                    <v-text-field
                      v-model.number="getApproverConfig(subject.id).max"
                      type="number"
                      outlined
                      dense
                      hide-details
                      min="0"
                      :disabled="!isApproverEnabled(subject.id)"
                      class="range-input"
                    ></v-text-field>
                  </div>
                </div>

                <!-- Mínimo general -->
                <div class="approver-row d-flex align-center px-2 mt-2">
                  <span class="approver-name">Mínimo de aprobación</span>
                  <div class="d-flex align-center" style="gap: 8px;">
                    <v-text-field
                      v-model.number="config.minimo"
                      type="number"
                      outlined
                      dense
                      hide-details
                      min="1"
                      :max="totalUsuariosHabilitados"
                      class="range-input"
                    ></v-text-field>
                    <span class="grey--text caption">de {{ totalUsuariosHabilitados }} usuarios</span>
                  </div>
                </div>

                <!-- ITO -->
                <div class="section-label mt-4 mb-2">Opciones ITO</div>

                <div class="approver-row d-flex align-center justify-space-between px-2 mb-1">
                  <span class="approver-name">Requiere aprobación ITO</span>
                  <v-switch
                    v-model="config.ito"
                    class="my-0"
                    dense
                    hide-details
                  ></v-switch>
                </div>

                <v-expand-transition>
                  <div v-if="config.ito" class="approver-row px-2 py-2 mt-1">
                    <v-text-field
                      v-model="config.tiempoMaximoITO"
                      label="Tiempo máximo ITO (horas)"
                      type="number"
                      outlined
                      dense
                      hide-details
                    ></v-text-field>
                  </div>
                </v-expand-transition>

              </div>
            </v-tab-item>

            <!-- Tab 2: Ejes A-Z -->
            <v-tab-item>
              <div class="py-3 px-5">
                <div class="section-label mb-2">Ejes A-Z</div>
                <div class="d-flex align-center mb-3">
                  <v-text-field
                    v-model="newEjeAZ"
                    label="Nuevo eje A-Z"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    @keyup.enter="addEjeAZ"
                  ></v-text-field>
                  <v-btn color="#2D4B95" dark small depressed :disabled="!newEjeAZ" @click="addEjeAZ">
                    <v-icon left small>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>
                <div class="chips-container" v-if="config.ejesAlfabeticos && config.ejesAlfabeticos.length > 0">
                  <v-chip
                    v-for="(eje, index) in config.ejesAlfabeticos"
                    :key="index"
                    close
                    small
                    class="ma-1"
                    @click:close="removeEjeAZ(index)"
                  >{{ eje }}</v-chip>
                </div>
                <div v-else class="empty-chips">No hay ejes A-Z definidos</div>
              </div>
            </v-tab-item>

            <!-- Tab 3: Ejes 0-1 -->
            <v-tab-item>
              <div class="py-3 px-5">
                <div class="section-label mb-2">Ejes 0-1</div>
                <div class="d-flex align-center mb-3">
                  <v-text-field
                    v-model="newEje01"
                    label="Nuevo eje 0-1"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    @keyup.enter="addEje01"
                  ></v-text-field>
                  <v-btn color="#2D4B95" dark small depressed :disabled="!newEje01" @click="addEje01">
                    <v-icon left small>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>
                <div class="chips-container" v-if="config.ejesNumericos && config.ejesNumericos.length > 0">
                  <v-chip
                    v-for="(eje, index) in config.ejesNumericos"
                    :key="index"
                    close
                    small
                    class="ma-1"
                    @click:close="removeEje01(index)"
                  >{{ eje }}</v-chip>
                </div>
                <div v-else class="empty-chips">No hay ejes 0-1 definidos</div>
              </div>
            </v-tab-item>

            <!-- Tab 4: Niveles -->
            <v-tab-item>
              <div class="py-3 px-5">
                <div class="section-label mb-2">Niveles</div>
                <div class="d-flex align-center mb-3">
                  <v-text-field
                    v-model="newNivel"
                    label="Nuevo nivel"
                    outlined
                    dense
                    hide-details
                    class="mr-2"
                    @keyup.enter="addNivel"
                  ></v-text-field>
                  <v-btn color="#2D4B95" dark small depressed :disabled="!newNivel" @click="addNivel">
                    <v-icon left small>mdi-plus</v-icon> Agregar
                  </v-btn>
                </div>
                <div class="chips-container" v-if="config.niveles && config.niveles.length > 0">
                  <v-chip
                    v-for="(nivel, index) in config.niveles"
                    :key="index"
                    close
                    small
                    class="ma-1"
                    @click:close="removeNivel(index)"
                  >{{ nivel }}</v-chip>
                </div>
                <div v-else class="empty-chips">No hay niveles definidos</div>
              </div>
            </v-tab-item>

            <!-- Tab 5: Zonas -->
            <v-tab-item>
              <div class="py-3 px-5">
                <div class="d-flex justify-space-between align-center mb-3">
                  <div class="section-label mb-0">Zonas</div>
                  <v-btn color="#2D4B95" dark small depressed @click="showZonaDialog = true">
                    <v-icon left small>mdi-plus</v-icon> Nueva zona
                  </v-btn>
                </div>

                <v-expansion-panels v-if="config.zonas && config.zonas.length > 0" accordion flat>
                  <v-expansion-panel
                    v-for="(zona, index) in config.zonas"
                    :key="index"
                    class="zona-panel mb-1"
                  >
                    <v-expansion-panel-header class="zona-header py-2 px-3">
                      <div class="d-flex align-center">
                        <v-icon color="#2D4B95" small class="mr-2">mdi-map-marker-radius</v-icon>
                        <span class="zona-name">{{ zona.name }}</span>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="zona-content">
                      <v-row dense class="pt-2">
                        <v-col cols="6">
                          <div class="field-label mb-1">Niveles</div>
                          <v-select
                            v-model="zona.niveles"
                            :items="config.niveles"
                            chips
                            outlined
                            dense
                            multiple
                            small-chips
                            hide-details
                            placeholder="Seleccionar"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <div class="field-label mb-1">Ejes A-Z</div>
                          <v-select
                            v-model="zona.ejesAlfabeticos"
                            :items="config.ejesAlfabeticos"
                            chips
                            outlined
                            dense
                            multiple
                            small-chips
                            hide-details
                            placeholder="Seleccionar"
                          ></v-select>
                        </v-col>
                        <v-col cols="6">
                          <div class="field-label mb-1">Ejes 0-1</div>
                          <v-select
                            v-model="zona.ejesNumericos"
                            :items="config.ejesNumericos"
                            chips
                            outlined
                            dense
                            multiple
                            small-chips
                            hide-details
                            placeholder="Seleccionar"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <div class="d-flex justify-end mt-2">
                        <v-btn text x-small color="error" @click="removeZona(index)">
                          <v-icon left x-small>mdi-delete</v-icon> Eliminar zona
                        </v-btn>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>

                <div v-else class="empty-state text-center py-6">
                  <v-icon size="36" color="grey lighten-1">mdi-map-marker-off</v-icon>
                  <p class="grey--text text--lighten-1 mt-2 mb-3 body-2">No hay zonas definidas</p>
                  <v-btn color="#2D4B95" dark small depressed @click="showZonaDialog = true">
                    <v-icon left small>mdi-plus</v-icon> Crear primera zona
                  </v-btn>
                </div>
              </div>
            </v-tab-item>

          </v-tabs-items>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="py-2 px-4">
          <v-spacer></v-spacer>
          <v-btn rounded outlined small @click="closeModal()">
            <span class="text-primary">Cancelar</span>
          </v-btn>
          <v-btn rounded color="#2D4B95" dark small depressed @click="saveConfig()" :loading="loading">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog nueva zona -->
    <v-dialog v-model="showZonaDialog" max-width="440px">
      <v-card>
        <v-card-title class="text-primary py-3 px-5 subtitle-1 font-weight-medium">
          Nueva zona
        </v-card-title>
        <v-card-text class="px-5 pb-2">
          <v-text-field
            v-model="newZona.name"
            label="Nombre de la zona"
            outlined
            dense
            :rules="requiredNameRule"
            class="mb-1"
          ></v-text-field>
          <v-select
            v-model="newZona.niveles"
            :items="config.niveles"
            chips
            outlined
            dense
            multiple
            small-chips
            label="Niveles"
            :disabled="!config.niveles || config.niveles.length === 0"
            :hint="!config.niveles || config.niveles.length === 0 ? 'Defina niveles primero' : ''"
            persistent-hint
            class="mb-1"
          ></v-select>
          <v-select
            v-model="newZona.ejesAlfabeticos"
            :items="config.ejesAlfabeticos"
            chips
            outlined
            dense
            multiple
            small-chips
            label="Ejes A-Z"
            :disabled="!config.ejesAlfabeticos || config.ejesAlfabeticos.length === 0"
            :hint="!config.ejesAlfabeticos || config.ejesAlfabeticos.length === 0 ? 'Defina ejes A-Z primero' : ''"
            persistent-hint
            class="mb-1"
          ></v-select>
          <v-select
            v-model="newZona.ejesNumericos"
            :items="config.ejesNumericos"
            chips
            outlined
            dense
            multiple
            small-chips
            label="Ejes 0-1"
            :disabled="!config.ejesNumericos || config.ejesNumericos.length === 0"
            :hint="!config.ejesNumericos || config.ejesNumericos.length === 0 ? 'Defina ejes 0-1 primero' : ''"
            persistent-hint
          ></v-select>
        </v-card-text>
        <v-card-actions class="px-5 pb-3">
          <v-spacer></v-spacer>
          <v-btn text small @click="showZonaDialog = false">Cancelar</v-btn>
          <v-btn color="#2D4B95" dark small depressed @click="addZona" :disabled="!newZona.name">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { saveConfig } from "@/helpers/api/entrega";

export default {
  name: "EntregaConfigModal",
  props: {
    closeModal: {
      type: Function,
      required: true,
    },
    modalStatus: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    activeTab: 0,
    tabs: [
      { name: "Base", value: 0 },
      { name: "Ejes A-Z", value: 1 },
      { name: "Ejes 0-1", value: 2 },
      { name: "Niveles", value: 3 },
      { name: "Zonas", value: 4 },
    ],
    // enabledApprovers: array of enabled jobType IDs (for v-switch binding)
    enabledApprovers: [],
    // approverConfigs: { [id]: { min, max } } — min siempre se mantiene en 0 (ya no es editable)
    approverConfigs: {},
    config: {
      minimo: null,
      ito: false,
      tiempoMaximoITO: null,
      ejesAlfabeticos: [],
      ejesNumericos: [],
      niveles: [],
      zonas: [],
      supervisor: null,
    },
    newEjeAZ: "",
    newEje01: "",
    newNivel: "",
    showZonaDialog: false,
    newZona: {
      name: "",
      niveles: [],
      ejesAlfabeticos: [],
      ejesNumericos: [],
    },
    loading: false,
    requiredNameRule: [(v) => !!v || "Campo requerido"],
  }),

  async mounted() {
    const projectID = this.$store.projectsStore.state.selectedProject.id;
    this.$store.usersStore.dispatch("jobTypesGet", projectID);
    this.$store.entregaStore.dispatch("getConfig", projectID);
  },

  computed: {
    currentConfig() {
      return this.$store.entregaStore.state.config;
    },

    // Total de usuarios habilitados = suma de los máximos configurados por perfil habilitado
    totalUsuariosHabilitados() {
      return this.enabledApprovers.reduce((total, id) => {
        const max = this.approverConfigs[id]?.max;
        return total + (Number.isFinite(max) ? max : 0);
      }, 0);
    },
  },

  watch: {
    currentConfig(data) {
      if (!data) return;

      this.config = {
        ...data,
        ejesAlfabeticos: [...(data.ejesAlfabeticos || [])],
        ejesNumericos: [...(data.ejesNumericos || [])],
        niveles: [...(data.niveles || [])],
        zonas: [...(data.zonas || [])],
        supervisor: data.supervisor || null,
      };

      // Hydrate enabled approvers and their max configs
      // Expected data.aprobadores format: [{ id, min, max }] or legacy [id, ...]
      // El min siempre se fuerza a 0, sin importar lo que venga persistido
      const aprobadores = data.aprobadores || [];
      this.enabledApprovers = [];
      this.approverConfigs = {};

      aprobadores.forEach((a) => {
        if (typeof a === "object" && a.id !== undefined) {
          this.enabledApprovers.push(Number(a.id));
          this.approverConfigs[Number(a.id)] = { min: 0, max: a.max ?? 1 };
        } else {
          // legacy: plain IDs
          this.enabledApprovers.push(Number(a));
          this.approverConfigs[Number(a)] = { min: 0, max: 1 };
        }
      });
    },
  },

  methods: {
    isApproverEnabled(id) {
      return this.enabledApprovers.includes(id);
    },

    getApproverConfig(id) {
      if (!this.approverConfigs[id]) {
        this.$set(this.approverConfigs, id, { min: 0, max: 1 });
      }
      return this.approverConfigs[id];
    },

    addEjeAZ() {
      if (!this.newEjeAZ) return;
      if (!this.config.ejesAlfabeticos) this.config.ejesAlfabeticos = [];
      if (!this.config.ejesAlfabeticos.includes(this.newEjeAZ)) {
        this.config.ejesAlfabeticos.push(this.newEjeAZ);
      }
      this.newEjeAZ = "";
    },

    removeEjeAZ(index) {
      this.config.ejesAlfabeticos.splice(index, 1);
    },

    addEje01() {
      if (!this.newEje01) return;
      if (!this.config.ejesNumericos) this.config.ejesNumericos = [];
      if (!this.config.ejesNumericos.includes(this.newEje01)) {
        this.config.ejesNumericos.push(this.newEje01);
      }
      this.newEje01 = "";
    },

    removeEje01(index) {
      this.config.ejesNumericos.splice(index, 1);
    },

    addNivel() {
      if (!this.newNivel) return;
      if (!this.config.niveles) this.config.niveles = [];
      if (!this.config.niveles.includes(this.newNivel)) {
        this.config.niveles.push(this.newNivel);
      }
      this.newNivel = "";
    },

    removeNivel(index) {
      this.config.niveles.splice(index, 1);
    },

    addZona() {
      if (!this.newZona.name) return;
      if (!this.config.zonas) this.config.zonas = [];
      this.config.zonas.push({
        id: Date.now(),
        name: this.newZona.name,
        niveles: [...this.newZona.niveles],
        ejesAlfabeticos: [...this.newZona.ejesAlfabeticos],
        ejesNumericos: [...this.newZona.ejesNumericos],
      });
      this.newZona = { name: "", niveles: [], ejesAlfabeticos: [], ejesNumericos: [] };
      this.showZonaDialog = false;
    },

    removeZona(index) {
      this.config.zonas.splice(index, 1);
    },

    showError(message) {
      this.$store.globalStore.dispatch("addMessage", {
        message,
        title: "Error",
        created: new Date(),
        type: "error",
        icon: "mdi-alert-circle",
        color: "#fb8c00",
      });
    },

    async saveConfig() {
      if (this.enabledApprovers.length === 0) {
        this.showError("Debe habilitar al menos un perfil de aprobador");
        return;
      }
      if (!this.config.minimo || this.config.minimo <= 0) {
        this.showError("El mínimo de aprobación no puede ser cero");
        return;
      }
      if (this.config.minimo > this.totalUsuariosHabilitados) {
        this.showError("El mínimo no puede ser mayor a la cantidad de usuarios habilitados");
        return;
      }

      this.loading = true;
      this.config.project_id = this.$store.projectsStore.state.selectedProject.id;

      try {
        const formData = new FormData();

        formData.append("minimo", this.config.minimo);
        formData.append("ito", this.config.ito);
        formData.append("project_id", this.config.project_id);

        if (this.config.ito && this.config.tiempoMaximoITO) {
          formData.append("tiempoMaximoITO", this.config.tiempoMaximoITO);
        }

        if (this.config.supervisor) {
          formData.append("supervisor", this.config.supervisor);
        }

        // Aprobadores as array of objects { id, min, max } — min siempre 0
        const aprobadoresPayload = this.enabledApprovers.map((id) => ({
          id,
          min: 0,
          max: this.approverConfigs[id]?.max ?? 1,
        }));
        formData.append("aprobadores", JSON.stringify(aprobadoresPayload));

        formData.append("ejesAlfabeticos", JSON.stringify(this.config.ejesAlfabeticos || []));
        formData.append("ejesNumericos", JSON.stringify(this.config.ejesNumericos || []));
        formData.append("niveles", JSON.stringify(this.config.niveles || []));
        formData.append("zonas", JSON.stringify(this.config.zonas || []));

        await saveConfig(formData);

        this.$store.globalStore.dispatch("addMessage", {
          message: "Configuración guardada exitosamente",
          title: "Éxito",
          created: new Date(),
          type: "success",
          icon: "mdi-check-circle",
          color: "#4CAF50",
        });

        this.$store.entregaStore.commit("setConfig", {
          ...this.config,
          aprobadores: aprobadoresPayload,
        });

        this.closeModal();
      } catch (error) {
        console.error("Error saving config:", error);
        this.showError("Error al guardar la configuración");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.text-primary {
  color: #2d4b95;
}

.tab-item {
  font-size: 13px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  min-width: 80px !important;
}

.section-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #888;
}

/* Approver column headers */
.approver-header {
  display: flex;
  align-items: center;
}

.approver-header-name {
  flex: 1;
}

.approver-header-ranges {
  gap: 8px;
}

.header-col {
  width: 110px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #999;
  text-align: center;
}

/* Approver rows */
.approver-row {
  background: #f8f8f8;
  border: 1px solid #ebebeb;
  border-radius: 6px;
}

.approver-row--disabled {
  opacity: 0.6;
}

.approver-name {
  font-size: 13px;
  flex: 1;
}

.approver-ranges {
  gap: 8px;
}

.range-input {
  width: 110px;
}

/* override vuetify input padding for compact look */
.range-input >>> .v-input__control .v-input__slot {
  min-height: 32px !important;
}

.range-input >>> input {
  text-align: center;
  font-size: 13px;
}

/* Chips */
.chips-container {
  padding: 8px;
  background: #f8f8f8;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  min-height: 40px;
}

.empty-chips {
  font-size: 12px;
  color: #bbb;
  padding: 8px 2px;
}

/* Zona panels */
.zona-panel {
  border: 1px solid #ebebeb !important;
  border-radius: 6px !important;
  box-shadow: none !important;
}

.zona-header {
  font-size: 13px;
  font-weight: 500;
  min-height: 40px !important;
}

.zona-name {
  font-size: 13px;
}

.zona-content >>> .v-expansion-panel-content__wrap {
  padding: 0 12px 12px;
}

.field-label {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #999;
}

/* Empty state */
.empty-state {
  border: 1px dashed #ddd;
  border-radius: 8px;
}

.v-btn {
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0 !important;
}
</style>